import { render, staticRenderFns } from "./taskToFeeBack.vue?vue&type=template&id=020ba6be&scoped=true&"
import script from "./taskToFeeBack.vue?vue&type=script&lang=js&"
export * from "./taskToFeeBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ba6be",
  null
  
)

export default component.exports